import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IPotentialSavingsDTO } from '../dto/i-potential-savings.dto';

@Component({
	selector: 'app-sp-allocation',
	templateUrl: './sp-allocation.component.html',
	styleUrls: ['./sp-allocation.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpAllocationComponent {
	@Input() public data: IPotentialSavingsDTO;

	@Output() public openTotalSavingPanel: EventEmitter<void> = new EventEmitter<void>();

	public roundAndSumNumbers(num1: number, num2: number): number {
		return Math.round(num1) + Math.round(num2);
	}
}
